import {MainRequest} from '../../Services/common';
import {download} from '../../Utils/common';

export interface WindowProps {
    logUrl: string;
    downloadUrl: string;
}

//导入记录
export enum ImportStatus {
    Success = '1',
    Error = '0',
}
export interface LogItem {
    createTime: string;
    id: string;
    code: string;
    status: ImportStatus;
}
export function getImportLog(url: string) {
    return MainRequest.post<PagedSuccessData<LogItem[]>>(url).then(
        res => res.data.data,
    );
}

//导出
export interface DownloadLogProps {
    id: string;
}
export function downloadLog(url: string, data: DownloadLogProps) {
    return download(url, {method: 'post', data: data});
}
